export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  searchText: string;
  sortField: string;
  sortOrder: string;
  status: number;
};

export type MasterTableDataType = {
  ip: string;
  clinicId: number;
  createdById: number;
  createdByDate: string;
  nutritionStatus: string;
  socioHistory: string;
  pastHistory: string;
  pfshTemplateId: number;
  chronicDisease: string;
  pfshTemplateName: string;
  pfshTemplateStatus: number;
};

export type MasterDataType = {
  pfshTemplateId: number;
  pfshTemplateName: string;
  pastHistory: string;
  chronicDisease: string;
  nutritionStatus: string;
  socioHistory: string;
  pfshTemplateStatus: number;
  pfshTemplateCreatedById: number;
  pfshTemplateClinicId: number;
  pfshTemplateCreatedByDate: string;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  pfshTemplateName: string;
  pastHistory: string;
  chronicDisease: string;
  nutritionStatus: string;
  socioHistory: string;
  pfshTemplateStatus: number;
};

export const initialFormData: MasterFormDataType = {
  pfshTemplateName: "",
  pastHistory: "",
  chronicDisease: "",
  nutritionStatus: "",
  socioHistory: "",
  pfshTemplateStatus: 1,
};
